import { render, staticRenderFns } from "./MemoList.vue?vue&type=template&id=aa880a96&scoped=true&"
import script from "./MemoList.vue?vue&type=script&lang=ts&"
export * from "./MemoList.vue?vue&type=script&lang=ts&"
import style0 from "./MemoList.vue?vue&type=style&index=0&id=aa880a96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa880a96",
  null
  
)

export default component.exports